"use client";
import React from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { openRequestCallback } from "@/redux/features/requestCallback/requestCallbackSlice";
import Icon from "@/components/icons/Icons";
import Image from "next/image";
export const CommitmentModel = () => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoId = "qId2MMfGyBs";
  return (
    <section className="max-w-section gap-6 xl:gap-16 px-4 md:px-0 flex flex-col md:flex-row mx-auto justify-center items-center mb-14 xl:mb-32 ">
      <div>
        <h2 className="font-bold text-xl sm:text-2xl sm:leading-8 text-center md:text-left lg:text-3xl lg:leading-9 leading-1.3 text-primaryBlack mb-4">
          See How Our Process Works
        </h2>
        <p className="text-[#404040] leading-1.3  text-sm text-center xl:text-left  xl:text-base xl:leading-6 mb-4 xl:mb-10 items-center">
          Understand each service, process, and what fits your needs best
        </p>
        <div className=" flex gap-3 xl:gap-5 mx-auto justify-center xl:justify-start w-full">
          <button
            onClick={() => {
              document.getElementById("mf-guidance")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
            className="py-3 w-1/2 rounded-xl xs:gap-2 flex text-white text-xs xxs:text-lg xxs:leading-6.5 text-center justify-center transition-all duration-300 hover:bg-white hover:text-black leading-1.5 items-center font-semibold bg-primaryBlue   border-2 border-primaryBlue "
          >
            Explore Services <Icon.rightArrow className="hidden xs:block" />
          </button>
          <button
            onClick={() =>
              dispatch(
                openRequestCallback({
                  buttonType: "advisory_call",
                  reason: "Mutual Fund Advisory Call",
                }),
              )
            }
            className="py-3 font-semibold w-1/2 text-xs xxs:text-lg border-2 transition-all duration-300 hover:bg-white hover:text-black  text-primaryBlue  border-primaryBlue rounded-xl"
          >
            Speak with an Advisor
          </button>
        </div>
      </div>
      <div className="flex justify-center items-center xl:py-10  ">
        <div className="relative w-82 h-43 xl:w-147.75 xl:h-77.5 rounded-2xl overflow-hidden shadow-xl shadow-black/30">
          <>
            <Image
              src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
              alt="Video thumbnail"
              className="w-full h-full object-cover rounded-2xl"
              width={480}
              height={360}
            />
            <div
              onClick={() => setIsModalOpen(true)}
              className="absolute inset-0 flex items-center justify-center cursor-pointer bg-black/20 rounded-2xl"
            >
              <div className="px-1 py-1 xl:px-4 xl:py-4 bg-transparent border-2 border-white rounded-full flex items-center justify-center text-xs md:text-3xl select-none">
                <Icon.playIcon />
              </div>
            </div>
          </>

          {isModalOpen && (
            <div
              className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
              onClick={() => setIsModalOpen(false)}
            >
              <div
                className="relative w-[90%] max-w-4xl aspect-video bg-black rounded-xl overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                <iframe
                  className="w-full h-full"
                  src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                  title="YouTube video"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
